import React, { useEffect } from "react";
import Notiflix from "notiflix";
import { baseUrl } from "../constant";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import serviceFunctions from "../Services";

const Confirmation = () => {
  let navigate = useNavigate();

  useEffect(() => {
    Notiflix.Loading.init({
      svgSize: "60px",
      svgColor: "#ffffff",
      backgroundColor: "rgba(0,0,0,0.7)",
    });

    Notiflix.Loading.standard({
      clickToClose: false,
      rtl: false,
    });
  }, []);

  useEffect(() => {
    const interval = setTimeout(() => {
      Notiflix.Loading.remove();
      navigate("/");
    }, 1000 * 60 * 5);

    return () => clearInterval(interval);
  }, [navigate]);

  useEffect(() => {
    let token = localStorage.getItem("token");

    // console.log("user_id",user_id)

    if (!token) {
      navigate('/spin-wheel');
    }

    const interval = setInterval(() => {
      (async () => {
        try {
          Notiflix.Loading.circle();

          let response = await axios.get(`${baseUrl}/user/subscription-status`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });

          if (response.data.statusCode === 200) {
            if (response.data.data.confirmed) {
              Notiflix.Loading.remove(); // Close the loader
              navigate("/spin-wheel");
            } else {
              // console.log('do nothing');
            }
          }

          Notiflix.Loading.remove();
        } catch (err) {
          Notiflix.Loading.remove();

          if (err?.response?.status === 401) {
            serviceFunctions.handleLogout();
          }

          console.error("Error checking subscription status:", err);
        }
      })();
    }, 3000);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="loader-container">
      <h1>Please wait...</h1>
      <div id="loader" />
    </div>
  );
};

export default Confirmation;
